import { ArrowTrendingUpIcon } from "@heroicons/react/24/solid";

import { ScoreBadge } from "@/widget/badge";

import { getHeader, getRows } from "./utils";

export const defaultTableHeaderStyle: React.CSSProperties = {
  textAlign: "center",
};

export const defaultTableCellStyle: React.CSSProperties = {
  textAlign: "center",
};

export const tableCellStyles: React.CSSProperties[] = [
  { textAlign: "center" },
  { textAlign: "left", backgroundColor: "#FAFAFA" },
  { textAlign: "left", backgroundColor: "#FAFAFA" },
  { textAlign: "left", backgroundColor: "#FAFAFA" },
  { textAlign: "right" },
  { textAlign: "right" },
  { textAlign: "center" },
  { textAlign: "center" },
  { textAlign: "center" },
];

export const header = getHeader({
  data: {
    ranking: 1,
    symbol: "CYTO",
    companyName: "Altamira therapeutics ltd",
    sector: "醫療保健",
    price: 600,
    priceChange: "10.0%",
    trendScore: 5,
    valueScore: 5,
    chipScore: 5,
  },
  map: {
    ranking: "排名",
    symbol: "股票代碼",
    companyName: "公司名稱",
    sector: "股票板塊",
    price: "股價",
    priceChange: "1W 漲跌幅",
    trendScore: "趨勢分數",
    valueScore: "價值分數",
    chipScore: "籌碼分數",
  },
});

export const rows = getRows({
  data: [
    ...Array(10).fill({
      ranking: 1,
      symbol: "CYTO",
      companyName: "Altamira therapeutics ltd",
      sector: "醫療保健",
      price: 600,
      priceChange: "10.0%",
      trendScore: 5,
      valueScore: 5,
      chipScore: 5,
    }),
  ],
  tableCellMap: {
    priceChange: (change) => (
      <p
        className="flex items-center justify-end gap-2 text-green-600"
        key="price change"
      >
        {change}
        <ArrowTrendingUpIcon className="h-5 w-5 text-green-600" />
      </p>
    ),
    trendScore: (score) => <ScoreBadge score={score} className="mx-auto" />,
    valueScore: (score) => <ScoreBadge score={score} className="mx-auto" />,
    chipScore: (score) => <ScoreBadge score={score} className="mx-auto" />,
  },
});
